// @flow

import React from 'react';
import { log } from '../../utils/jsUtils';
import { useSelector } from 'react-redux';
import { selectUser } from '../../reduxStore/modules/user/selectors';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

import HeaderTopBar from '../HeaderTopBar';
import { createClasses } from '../../utils/stylesUtils';
import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';

type Props = {
  mobileOpen: bool, 
  usehandleDrawerToggle: Function,
};

const BillingHeader = (props: Props) => {
  log('[BillingHeader] props: ', props);
  const theme = useTheme();
  const classes = createClasses(memberHeaderStyles, theme);
  
  const {
    usehandleDrawerToggle
  } = props;

  const user = useSelector(selectUser);

  return (
    <AppBar 
      position="fixed"
      sx={classes.appBar}
    >
      <Toolbar
        disableGutters
        sx={classes.toolbar}
      >
        <Grid 
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography 
              variant='h2'
              sx={classes.pageTitle}
            >
              {'Account > '}
              <a href='/billing'>{'Billing'}</a>
            </Typography>
          </HeaderTopBar>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default BillingHeader;
